// extracted by mini-css-extract-plugin
export var backupIcon = "_sr-1";
export var image = "_sr-0";